(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.unlockMath = {}));
})(this, (function (exports) { 'use strict';

    const MIN_LTV = '1000';
    const MAX_LTV = '7500';
    const multiLoanBorrowValues = (nfts) => {
        if (nfts.length == 0) {
            throw new Error('Must provide at least one NFT');
        }
        let totalValuation = BigInt(0);
        let totalAvailableToBorrow = BigInt(0);
        for (const nftKey in nfts) {
            const nft = nfts[nftKey];
            const ltv = nft.ltv;
            if (parseInt(ltv) > parseInt(MAX_LTV) || parseInt(ltv) < parseInt(MIN_LTV)) {
                throw new Error(`LTV ${ltv} is not within the allowed range of ${MIN_LTV} to ${MAX_LTV}`);
            }
            const valuation = nft.valuation;
            totalValuation += BigInt(valuation);
            totalAvailableToBorrow += BigInt(valuation) * BigInt(ltv);
        }
        const totalLtv = (totalAvailableToBorrow / totalValuation).toString();
        totalAvailableToBorrow /= BigInt('10000');
        return {
            ltv: totalLtv,
            valuation: totalValuation.toString(),
            availableToBorrow: totalAvailableToBorrow.toString()
        };
    };

    const healthFactor = (params) => {
        let { collateral, debt, liquidationThreshold, variations } = params;
        let totalCollateral = collateral;
        let totalDebt = debt;
        if (params.variations?.collateral)
            totalCollateral += variations.collateral;
        if (variations?.debt)
            totalDebt += variations.debt;
        if (totalCollateral <= BigInt('0') || totalDebt <= BigInt('0')) {
            return BigInt('0');
        }
        return BigInt((totalCollateral * liquidationThreshold) / totalDebt);
    };

    const LIQUIDATION_THRESHOLD = BigInt(8500);
    function calculateMinimumRepay(params) {
        if (params.initialLoans.length == 0)
            throw new Error('Must provide at least one loan');
        if (params.indicesToDelete.length == 0 && !params.auction)
            throw new Error('Must provide at least one index to delete');
        if (params.auction && !params.liquidationThreshold)
            throw new Error('Must provide liquidation threshold for auction');
        const totalDebt = params.totalDebt;
        let totalValuation = BigInt(0);
        let initialAvailableToBorrow = BigInt(0);
        let finalAvailableToBorrow = BigInt(0);
        for (const loan of params.initialLoans) {
            totalValuation += loan.valuation;
            initialAvailableToBorrow += loan.valuation * loan.ltv;
        }
        if (params.auction)
            return params.totalDebt - (totalValuation * params.liquidationThreshold) / BigInt(10000);
        initialAvailableToBorrow = initialAvailableToBorrow / BigInt(10000);
        const finalArray = params.initialLoans.filter((_, i) => !params.indicesToDelete.includes(i));
        for (const loan of finalArray) {
            finalAvailableToBorrow += loan.valuation * loan.ltv;
        }
        finalAvailableToBorrow = finalAvailableToBorrow / BigInt(10000);
        const minimumRepay = totalDebt - finalAvailableToBorrow;
        if (minimumRepay < BigInt(0))
            return BigInt(0);
        return minimumRepay;
    }

    const calculateLiquidationPrice = (params) => {
        if (params.liquidationThreshold <= 0n || params.debt <= 0n)
            return 0n;
        return (params.debt * BigInt(10000)) / params.liquidationThreshold;
    };

    exports.LIQUIDATION_THRESHOLD = LIQUIDATION_THRESHOLD;
    exports.MAX_LTV = MAX_LTV;
    exports.MIN_LTV = MIN_LTV;
    exports.calculateLiquidationPrice = calculateLiquidationPrice;
    exports.calculateMinimumRepay = calculateMinimumRepay;
    exports.healthFactor = healthFactor;
    exports.multiLoanBorrowValues = multiLoanBorrowValues;

}));
